export default "__VITE_ASSET__BKeoXRzx__"